import React, {useMemo, useState} from "react";
import {useStore, useFetch} from "@vigo/hooks";
import {Table, Spin, Button, Select, Form, Col, Input, Row} from "antd";
import {useTranslation} from "react-i18next";
import {useObserver} from "mobx-react-lite";
import {DeleteIntegratorModal} from "./Modal/DeleteIntegratorModal";
import {useHistory} from "react-router-dom";
import {ChangeStatusIntegratorModal} from "./Modal/ChangeStatusIntegratorModal";
import {debounce} from "lodash";
import {formatPhoneNumber} from "../../../utils/helpers";
import {EyeText} from "./EyeText";

export const IntegratorPage = ({companyId: companyIdState}) => {
    const stores = useStore();
    const history = useHistory();
    const [refetch, setRefetch] = useState(false);
    const [type, setType] = useState(null);
    const [name, setNameState] = useState(null);
    const [isActive, setIsActive] = useState(null);
    const {t} = useTranslation(["integratorPage"]);
    const setName = useMemo(() => {
        const loadOptions = value => {
            setNameState(value);
        };
        return debounce(loadOptions, 600);
    }, []);
    const [, integratorListRecords] = useFetch({
        defaultDataValue: [],
        fetchFn: stores.integratorStore.integratorList.bind(null, {
            type,
            isActive: isActive === true || isActive === false ? String(isActive) : null,
            name
        }),
        initialCall: true,
        showLoading: true,
        dependencies: [refetch, type, isActive, name]
    });

    return useObserver(() => (
        <div>
            <h1>
                Entegratör Listesi{" "}
                {companyIdState &&
                    stores.appStore.companyListFilter.find(c => c._id.toString() === companyIdState)
                        ?.companyName}
            </h1>
            {!companyIdState && (
                <Row
                    style={{
                        gap: "20px"
                    }}
                >
                    <Col
                        style={{
                            flex: 1
                        }}
                    >
                        <h5>{t("fields.name", {ns: "integratorDetail"})}</h5>
                        <Input onChange={e => setName(e.target.value)} placeholder="Adı" />
                    </Col>
                    <Col
                        style={{
                            flex: 1,
                            width: "100%"
                        }}
                    >
                        <h5>{t("fields.type", {ns: "integratorDetail"})}</h5>
                        <Select
                            name="type"
                            value={type}
                            allowClear
                            onChange={value => setType(value)}
                            style={{
                                width: "100%"
                            }}
                        >
                            {["cargo", "pos", "c2c"].map(type => (
                                <Select.Option key={type} value={type} name="type">
                                    {t(`types.${type}`, {
                                        ns: "integratorDetail"
                                    })}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col
                        style={{
                            flex: 1,
                            width: "100%"
                        }}
                    >
                        <h5>{t("fields.isActive", {ns: "integratorDetail"})}</h5>
                        <Select
                            name="isActive"
                            allowClear
                            value={isActive}
                            onChange={value => setIsActive(value)}
                            style={{
                                width: "100%"
                            }}
                        >
                            <Select.Option value={true} name="type">
                                {"Aktif"}
                            </Select.Option>
                            <Select.Option value={false} name="type">
                                {"Pasif"}
                            </Select.Option>
                        </Select>
                    </Col>
                </Row>
            )}
            <Button
                onClick={() => {
                    history.push("/new-integrator");
                }}
                style={{
                    marginTop: "20px",
                    marginBottom: "20px"
                }}
                type={"primary"}
            >
                Yeni Entegratör
            </Button>

            <Spin spinning={false}>
                <Table
                    rowKey="_id"
                    dataSource={integratorListRecords?.data ?? []}
                    data-testid="integratorTable"
                >
                    <Table.Column
                        dataIndex="name"
                        title={t("fields.name", {ns: "integratorDetail"})}
                        render={text => <span data-testid="integratorPage">{text}</span>}
                    />
                    <Table.Column
                        dataIndex="type"
                        title={t("fields.type", {ns: "integratorDetail"})}
                        render={text => <span data-testid="integratorPage">{t(`types.${text}`, {ns: "integratorDetail"})}</span>}
                    />
                    <Table.Column
                        dataIndex="clientId"
                        title={t("fields.clientId", {ns: "integratorDetail"})}
                        render={(clientId) => (
                            <span data-testid="integratorDetail">
                                <EyeText text={clientId} />
                            </span>
                        )}
                    />
                    <Table.Column
                        dataIndex="authorizedName"
                        title={t("fields.authorizedName", {ns: "integratorDetail"})}
                        render={text => <span data-testid="integratorPage">{text}</span>}
                    />
                    <Table.Column
                        dataIndex="authorizedPhone"
                        title={t("fields.authorizedPhone", {ns: "integratorDetail"})}
                        render={text => <span data-testid="integratorPage">{formatPhoneNumber(text)}</span>}
                    />
                    <Table.Column
                        dataIndex="email"
                        title={t("fields.email", {ns: "integratorDetail"})}
                        render={email => (
                            <span data-testid="integratorPage">{email}</span>
                        )}
                    />
                    <Table.Column
                        dataIndex="isActive"
                        title={t("fields.isActive", {ns: "integratorDetail"})}
                        render={(isActive, integrator) => (
                            <span data-testid="integratorPage">
                                <ChangeStatusIntegratorModal
                                    integratorId={integrator._id}
                                    setRefetch={setRefetch}
                                    isActive={isActive}
                                />
                            </span>
                        )}
                    />
                    <Table.Column
                        title={t("fields.settings", {ns: "integratorDetail"})}
                        render={(text, integrator) => (
                            <div style={{
                                display:"flex"
                                }}>
                                <span data-testid="integratorPage"></span>
                                <Button
                                    style={{
                                        margin: "8px"
                                    }}
                                    data-testid="integratorPage"
                                    onClick={() => {
                                        history.push("/edit-integrator/" + integrator._id);
                                    }}
                                >
                                    Düzenle
                                </Button>
                                <DeleteIntegratorModal
                                    integratorId={integrator._id}
                                    setRefetch={setRefetch}
                                />
                            </div>
                        )}
                    />
                </Table>
            </Spin>
        </div>
    ));
};
